export default __webpack_public_path__ + "static/media/herobackfr1.e72561cc.png";